const globalLegacyI18n = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/campaign-creation-advanced');

const parseLoadDate = (i18n, dateString) => globalLegacyI18n.parseDate(dateString.substring(0, 10), { raw: 'yyyy-MM-dd' });

const parseDateFromAPIFormat = (i18n, date) => {
  if (date == null) {
    return null;
  }

  if (typeof date === 'string') {
    return globalLegacyI18n.parseDate(date.substring(0, 10), { raw: 'M/d/yyyy' });
  }

  return date;
};


// keeping unused i18n in case we find bugs with replacement to globalLegacyI18n and change need to be reverted
export const formatDateToAPIFormat = (i18n, date) => {
  if (date == null) {
    return '';
  }

  if (typeof date === 'string') {
    return date;
  }

  return globalLegacyI18n.formatDate(date, {
    raw: 'M/d/yyyy',
  });
};

export const modelToViewModelForDateSetting = ({ model, i18n }) => ({
  StartDate: parseLoadDate(i18n, model.StartDate),
  EndDate: model.EndDate ? parseLoadDate(i18n, model.EndDate) : undefined,
});

export const bulkModelToViewModelForDateSetting = ({ model, i18n }) => ({
  StartDate: parseDateFromAPIFormat(i18n, model.StartDate),
  EndDate: model.EndDate ? parseDateFromAPIFormat(i18n, model.EndDate) : undefined,
});

export const viewModelToBulkModelForDateSetting = ({ viewModel, i18n }) => ({
  StartDate: formatDateToAPIFormat(i18n, viewModel.data.StartDate),
  EndDate: viewModel.data.EndDate ? formatDateToAPIFormat(i18n, viewModel.data.EndDate) : '1/1/3000',
});
